import React from 'react';
import {Spin} from "antd";
import {Card} from "reactstrap";
import "./LoadingCard.scss";

const LoadingCard = () => {
    return (
        <Card>
            <div className='loading loading-card'>
                {/* The empty child puts Spin in "nest" mode, the only mode
                    where antd v5 renders the tip. */}
                <Spin tip="Зареждане…" size="large">
                    <div />
                </Spin>
            </div>
        </Card>
    );
};

export default LoadingCard;